import { render, staticRenderFns } from "./CotPropostaAccessoPage.vue?vue&type=template&id=ff2c0872"
import script from "./CotPropostaAccessoPage.vue?vue&type=script&lang=js"
export * from "./CotPropostaAccessoPage.vue?vue&type=script&lang=js"
import style0 from "./CotPropostaAccessoPage.vue?vue&type=style&index=0&id=ff2c0872&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports